import {
  GET_LESSON_RESULT_FILE_STARTED,
  GET_LESSON_RESULT_FILE_COMPLETED,
  GET_LESSON_RESULT_FILE_FAILED,
} from '../actions/types';

const initialState = {
  fetched: false,
  success: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LESSON_RESULT_FILE_STARTED:
      return {
        fetched: false,
        success: false,
        error: false,
      };
    case GET_LESSON_RESULT_FILE_COMPLETED:
      return {
        ...state,
        fetched: true,
        success: true,
      };
    case GET_LESSON_RESULT_FILE_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    default: return state;
  }
};
